import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-xl flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-2xl">SN</span>
              </div>
              <span className="text-2xl font-bold text-white">
                Sakthi Net Center
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Your trusted partner for all essential e-services, government documentation, financial applications, and travel bookings in Pudukkottai. Fast, reliable, and secure.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <span className="text-lg font-semibold mb-6 block text-white">Quick Links</span>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm flex items-center">
                  <span className="w-1.5 h-1.5 rounded-full bg-cyan-500 mr-2"></span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm flex items-center">
                  <span className="w-1.5 h-1.5 rounded-full bg-cyan-500 mr-2"></span>
                  All Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <span className="text-lg font-semibold mb-6 block text-white">Contact Information</span>
            <ul className="space-y-4">
              <li className="flex items-start space-x-4">
                <div className="w-10 h-10 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-cyan-400" />
                </div>
                <div className="pt-2">
                  <p className="text-slate-300 text-sm leading-relaxed">
                    Plot No. 1112, PSK Residency,<br />
                    Periyar Nagar, Pudukkottai - 622 003
                  </p>
                </div>
              </li>
              <li className="flex items-center space-x-4">
                <div className="w-10 h-10 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-5 h-5 text-cyan-400" />
                </div>
                <div>
                  <p className="text-slate-300 text-sm font-medium">8531021480</p>
                  <p className="text-slate-500 text-xs">Mon-Sat, 9:00 AM - 8:00 PM</p>
                </div>
              </li>
              <li className="flex items-center space-x-4">
                <div className="w-10 h-10 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-5 h-5 text-cyan-400" />
                </div>
                <p className="text-slate-300 text-sm break-all">srisakthinet1612@gmail.com</p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm text-center md:text-left">
            © {new Date().getFullYear()} Sakthi Net Center. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;